import { Grid } from '@mui/material';
import { Button } from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosSharpIcon from '@mui/icons-material/ArrowBackIosSharp';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface FooterButtonProps {
  isDisabledNextBtn: boolean;
  onClickNext: () => Promise<void>;
  onClickBack: () => void;
}

const FooterButton: React.FC<FooterButtonProps> = ({
  isDisabledNextBtn,
  onClickBack,
  onClickNext,
}) => {
  const { t } = useTranslation();

  // 処理中フラグ
  const isProcessing = useRef(false);

  /** 次へボタン押下 */
  const handleClickNext = async () => {
    if (isProcessing.current) {
      // 連打防止
      return;
    }
    isProcessing.current = true;
    try {
      await onClickNext();
    } finally {
      isProcessing.current = false;
    }
  };

  return (
    <React.Fragment>
      <Grid size={0.15} />
      <Grid size={1.5}>
        <Button
          variant="outlined"
          fullWidth
          sx={{ justifyContent: 'center' }}
          onClick={onClickBack}
          startIcon={
            <ArrowBackIosSharpIcon
              style={{
                verticalAlign: 'middle',
                fontSize: '16px',
              }}
            />
          }
        >
          {/* 診断結果の修正(検査画面へ戻る) */}
          {t('BTN_BACK')}
        </Button>
      </Grid>
      <Grid size={8.7} />
      <Grid size={1.5}>
        <Button
          variant="contained"
          fullWidth
          sx={{ justifyContent: 'center' }}
          disabled={isDisabledNextBtn || isProcessing.current}
          onClick={handleClickNext}
          endIcon={
            <ArrowForwardIosSharpIcon
              style={{
                verticalAlign: 'middle',
                fontSize: '16px',
              }}
            />
          }
        >
          {t('BTN_NEXT')}
        </Button>
      </Grid>
      <Grid size={0.15} />
    </React.Fragment>
  );
};

export default FooterButton;
